<script lang="ts">
  import { getContext } from 'svelte';
  import { ListCard } from './components/list';
  import { Splide, SplideSlide } from '@splidejs/svelte-splide';
  import { Heading, ShowMoreButton, Wrapper } from './components';
  import type {
    GlobalProperties,
    UseFormattedProps,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
  export let settings: GlobalProperties;
  // todo: where is this page coming from? it is affecting the slider
  export let page = '';

  const isEditable = getContext<boolean>('isEditable') || false;

  $: ({ borderRadius } = settings);
  $: currentItems = isEditable ? properties?.items.length : 3;

  const showMore = () => {
    currentItems = properties.items.length;
  };

  const hideItems = () => {
    currentItems = 3;
  };
</script>

<Wrapper style="background:var(--vlt-lp-background);">
  {#if properties?.items.length}
    <div class="list-container {properties.cardStyle}">
      <div class="list-content" id={properties?.anchor}>
        {#if properties.heading}
          <Heading type={'h2'} css={'margin-bottom:50px;text-align:center;'}
            >{@html properties.heading}</Heading
          >
        {/if}

        {#if properties.scroller && properties.items.length > 3}
          <div class="slider-container">
            <!-- todo: type should be start: number; -->
            <Splide
              options={{
                start: { page },
                type: 'loop',
                perPage: 3,
                gap: '1em',
                width: 'auto',
                height: 'auto',
                classes: {
                  prev: 'splide__arrow--prev list-prev',
                  next: 'splide__arrow--next list-next',
                },
                breakpoints: {
                  960: {
                    perPage: 2,
                  },
                  846: {
                    destroy: true,
                  },
                },
                pagination: false,
              }}
            >
              {#each properties.items as list}
                <SplideSlide>
                  <ListCard
                    {properties}
                    {borderRadius}
                    isSlide={properties.scroller}
                    image={list.image}
                    heading={list.heading}
                    text={list.text}
                    button={list.button}
                    imageSize={properties.imageSize}
                    alignment={properties.alignment}
                    cardStyle={properties.cardStyle}
                  />
                </SplideSlide>
              {/each}
            </Splide>
          </div>
        {:else}
          <div
            class="items-list {properties.items.length < 3 ? 'centered' : ''}"
          >
            {#each properties.items.slice(0, currentItems) as list, index}
              <li class="card-item">
                <ListCard
                  {properties}
                  {borderRadius}
                  length={properties.items.length}
                  image={list.image}
                  heading={list.heading}
                  text={list.text}
                  button={list.button}
                  imageSize={properties.imageSize}
                  alignment={properties.alignment}
                  cardStyle={properties.cardStyle}
                />
              </li>
            {/each}
          </div>

          <ShowMoreButton
            on:showMore={showMore}
            on:showLess={hideItems}
            {currentItems}
            itemsLength={properties.items.length}
            {isEditable}
          />
        {/if}
      </div>
    </div>
  {/if}
</Wrapper>

<style>
  .list-prev {
    left: -5vw !important;
  }
  .list-next {
    right: -3vw !important;
  }

  .list-container {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 0 15px;
    box-sizing: border-box;
  }
  .list-container.card {
    display: flex;
  }
  .list-content {
    width: 100%;
  }
  :global(.splide__list) {
    margin-bottom: 30px !important;
    align-items: flex-start;
  }
  :global(.splide__track) {
    padding-right: 15px !important;
  }
  .slider-container {
    width: 100%;
    max-width: 1247px;
    margin: 0 auto;
  }

  .items-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    width: 100%;
    max-width: 1230px;

    margin: 0 auto;
  }

  .items-list.centered {
    justify-content: center;
  }

  .card-item {
    width: calc(33% - 5px);
    list-style: none;
  }

  @media screen and (max-width: 1024px) {
    .card-item {
      width: calc(50% - 5px);
    }
  }

  @media screen and (max-width: 768px) {
    .card-item {
      width: 100%;
    }
  }
</style>
